import { Col, TextLabel } from "../lib";
import { createStyles } from "../theme";
import { avatarStyles } from "./avatar";

const SUPPORT_USER_ID = 189481;

type Props = {
  disabled?: boolean;
  userId: number;
  userName: string;
  small?: boolean;
};

export function AvatarText({
  disabled = false,
  small,
  userId,
  userName,
}: Props) {
  // Vars
  const isSupport = userId === SUPPORT_USER_ID;
  const initials = isSupport
    ? "SMO"
    : userName.split(" ").reduce((acc, namePart) => acc + namePart[0], "");

  // Render
  return (
    <Col.C
      style={[
        avatarStyles.container,
        $.container,
        isSupport && $.support,
        small && avatarStyles.small,
        disabled && $.disabled,
      ]}
    >
      <TextLabel color={isSupport ? "onPrimary" : undefined} em>
        {initials}
      </TextLabel>
    </Col.C>
  );
}

const $ = createStyles({
  container: {
    backgroundColor: "primaryDim",
    borderWidth: 1,
    borderColor: "primaryDim",
  },
  support: {
    backgroundColor: "primary",
  },
  disabled: {
    backgroundColor: "surfaceDim",
    borderColor: "outline",
  },
});
